import script from "./HeroCarousel.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeroCarousel.vue?vue&type=script&setup=true&lang=ts"

import "./HeroCarousel.vue?vue&type=style&index=0&id=3bfbf7b5&scoped=true&lang=sass"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bfbf7b5"]])

export default __exports__